import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "g-select text-xs sm:text-sm text-left inline-block w-full" }
const _hoisted_2 = {
  key: 0,
  class: "required-dot bg-dot-red"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "請選擇", -1)
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["input-label relative font-normal pb-2 text-breadcrumb-color tracking-widest", [{ required: _ctx.required }]])
        }, [
          _createTextVNode(_toDisplayString(_ctx.label), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "select-wrap",
      style: _normalizeStyle({ height: _ctx.height, width: '100%', lineHeight: _ctx.height })
    }, [
      _withDirectives(_createElementVNode("select", {
        ref: "dropdown",
        name: "",
        id: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValueRef) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
      }, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            key: item,
            value: item[_ctx.itemValue]
          }, _toDisplayString(item[_ctx.itemText]), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.modelValueRef]
      ])
    ], 4)
  ]))
}